module.exports = __webpack_public_path__ + "img/card_at_requisitionmanagement_back.54d9eb77.svg";